<template>
<div id="catalogos_errores">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
         <base-material-card color="primary" icon="mdi-account" title="Conteo" class="elevation-1 px-5 py-3">
        <v-row align-center justify-center>
            <v-col >
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha De" color="secondary" prepend-icon="event" @blur="model.fecha_de = parse_date(model.fecha_de)" :rules="[rules.required, valida_fecha]">
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col >
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha A" color="secondary" prepend-icon="event" @blur="model.fecha_a = parse_date(model.fecha_a)" :rules="[rules.required, valida_fecha]">
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                   <v-col >
                          <v-btn color="success" @click.native="cargar()">
                    <v-icon>done</v-icon> {{ "Consultar" }}
                  </v-btn>
                  </v-col>
                  </v-row>
            <v-row>
            <v-col xs="12">


                    <v-card-text>
                        <div id="datagrid">
                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>

            </v-col>
        </v-row>
         </base-material-card>
    </v-container>


</div>
</template>



<script>
import moment from "moment";

export default {
    created: function () {
        this.URL = this.$hostname;
        const fecha = new Date();
        // setMonth(mesActual - 1) y día 1
        const primerDiaMesAnterior = this.parse_date(new Date(fecha.getFullYear(), fecha.getMonth() - 1, 1));
        const ultimoDiaMesAnterior = this.parse_date(new Date(fecha.getFullYear(), fecha.getMonth(), 0));

        this.model.fecha_de = primerDiaMesAnterior;
        this.model.fecha_a = ultimoDiaMesAnterior;
    },
    computed: {
        tituloModal() {
            return this.updateModel === false ? "Nuevo Error" : "Editar Error";
        },
    },
    data: () => ({
        URL: "",
        tabla: "errores_webservice",
        show1: false,
        show2: false,
         menu1: false,
        menu2: false,
        modal: false,
  rules: {
        required: v => !!v || "Este campo es requerido",
        decimal: value => {
          const pattern = /^[\d]*(\.{0,1}[\d]*)$/;
          return pattern.test(value) || "Número decimal no válido";
        },
        entero: function(numero) {
          const pattern = /^[\d]*$/;
          return pattern.test(numero) || "Debe ser un número entero";
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Correo electrónico no valido";
        },
        rfc: v =>
          (v && v.length >= 9 && v.length < 15) || "RFC debe tener al menos 9 caractéres y 14 caractéres"
      },

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Errores Webservice",
                disabled: true,
                href: "",
            },
        ],
        model: {
        fecha_de: '',
        fecha_a: ''},
        updateModel: false,
        columns: ["rfc", "total" ],
        options: {
            filterable: true,
            headings: {
                error: "Error Webservice",
                descripcion: "Descripción Simple",
                actions: "Operaciones"
            }
        },
        items: [],
    }),
    methods: {
       parse_date(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    valida_fecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
        cargar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            var self = this;

            this.$axios.post(this.URL + "/carta_porte/reporte_saldos/", self.model)
                .then(res => {
                    self.items = res.data;
                    console.log(res.data);
                    self.items.forEach(element => {
                      element.total = 0

                      if (element.creditos.length > 0 ) {
                       console.log(element);
                        element.creditos.forEach(t => {
                            element.total += parseInt(t.total);
                        });
                      }

                    });
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: "",
                    });
                    console.log(err);
                }).then(() => {
                    self.$root.$dialogLoader.hide();
                });
        },
      }

    };
</script>

<style scoped>
.VueTables>>>tbody td {
    white-space: normal !important;
}
</style>
